<template>
  <div class="management-page-outer-container">
    <router-view />
    <custom-fields-table
      v-if="$route.name === 'custom-fields'"
      :pagination-from-parent="pagination"
      @update-pagination="pagination = $event"
      :search-from-parent="search"
      @update-search="search = $event"
    >
      <management-add-button
        :label="$t('AddCustomField')"
        @buttonClick="$router.push({ name: 'custom-field-create' })"
        :disabled="!this.userHasManagementPermission('custom_field_store')"
        :list-missing-permissions="[]"
      />
    </custom-fields-table>
  </div>
</template>

<script>
import ManagementButton from "../../../Management/ManagementButton";
import CustomFieldsTable from "./CustomFieldsTable";
import ManagementAddButton from "@/components/Management/ManagementAddButton";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "CustomFields",

  components: {
    ManagementButton,
    CustomFieldsTable,
    ManagementAddButton
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      /**
       * Defines how many items will be presented in a page of the table, by default
       */
      pagination: {
        rowsPerPage: 10
      },
      /**
       * Search value input by the user
       */
      search: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/CustomFields/CustomFields.vue